<template>
  <div>
    <div>
      <h1 class="mr-sm-4 header-tablepage mb-3">Options System</h1>
    </div>
    <b-tabs v-model="tabIndex">
      <b-tab title="General">
        <!-- <div class="title-tabs mt-3">Additional Consent Detail</div> -->
        <div class="title-tabs">Marketplace (Count Only Active)</div>
        <b-container class="no-gutters bg-white" v-if="isLoading">
          <div class="pt-3">
            <b-row>
              <b-col lg="6" md="6" sm="12" xs="12">
                <InputText
                  textFloat="Number of Marketplace"
                  placeholder="Number of Marketplace"
                  type="text"
                  name="max_number_of_marketplace"
                  v-model="form.max_number_of_marketplace"
                  :v="$v.form.max_number_of_marketplace"
                  :isValidate="$v.form.max_number_of_marketplace.$error"
                  isRequired
                />
              </b-col>
            </b-row>
          </div>
        </b-container>
        <div class="title-tabs">Automation (Count Only Active)</div>
        <b-container class="no-gutters bg-white" v-if="isLoading">
          <div class="pt-3">
            <b-row>
              <b-col lg="6" md="6" sm="12" xs="12">
                <InputText
                  textFloat="Number Of Automation"
                  placeholder="Number Of Automation"
                  type="number"
                  name="max_number_of_automation"
                  v-model="form.max_number_of_automation"
                  :v="$v.form.max_number_of_automation"
                  :isValidate="$v.form.max_number_of_automation.$error"
                  isRequired
                />
              </b-col>
            </b-row>
          </div>
        </b-container>
        <div class="title-tabs">User Admin/Staff</div>
        <b-container class="no-gutters bg-white" v-if="isLoading">
          <div class="pt-3">
            <b-row>
              <b-col lg="6" md="6" sm="12" xs="12">
                <InputText
                  textFloat="Number of Admin/Staff"
                  placeholder="Number of Admin/Staff"
                  type="text"
                  name="max_number_of_user"
                  v-model="form.max_number_of_user"
                  :v="$v.form.max_number_of_user"
                  :isValidate="$v.form.max_number_of_user.$error"
                  isRequired
                />
              </b-col>
            </b-row>
          </div>
        </b-container>
        <div class="title-tabs">Setting Menu</div>
        <b-container class="no-gutters bg-white" v-if="isLoading">
          <div class="py-3">
            <b-row>
              <template
                v-for="(item, index) in form.masterSettingSectionEntity_List"
              >
                <b-col lg="6" md="6" sm="12" xs="12" :key="index">
                  <b-form-checkbox
                    v-model="item.is_active"
                    :value="1"
                    :unchecked-value="0"
                    >{{ item.name }}
                  </b-form-checkbox>
                </b-col>
                <div class="break-normal" :key="'break-' + index"></div>
              </template>
            </b-row>
          </div>
        </b-container>
      </b-tab>
    </b-tabs>

    <FooterAction routePath="/setting/additional-consent" @submit="save()" />
  </div>
</template>
<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import minValue from "vuelidate/lib/validators/minValue";
export default {
  data() {
    return {
      form: {
        max_number_of_marketplace: 0,
        max_number_of_automation: 0,
        max_number_of_user: 0,

        masterSettingSectionEntity_List: [
          {
            id: 1,
            name: "Product & Inventory",
            sort_order: 1,
            is_active: 0,
          },
          {
            id: 2,
            name: "Customer Form Setting",
            sort_order: 2,
            is_active: 0,
          },
          {
            id: 3,
            name: "Third Party & Plugins",
            sort_order: 3,
            is_active: 1,
          },
          {
            id: 4,
            name: "Brand & Branch Setting",
            sort_order: 4,
            is_active: 1,
          },
          {
            id: 5,
            name: "Theme",
            sort_order: 5,
            is_active: 1,
          },
          {
            id: 6,
            name: "Line Setting",
            sort_order: 6,
            is_active: 1,
          },
          {
            id: 7,
            name: "Email Setting",
            sort_order: 7,
            is_active: 1,
          },
          {
            id: 8,
            name: "Receipt",
            sort_order: 8,
            is_active: 1,
          },
          {
            id: 9,
            name: "Ticket",
            sort_order: 9,
            is_active: 1,
          },
          {
            id: 10,
            name: "Other",
            sort_order: 10,
            is_active: 1,
          },
          {
            id: 11,
            name: "System Configuration",
            sort_order: 11,
            is_active: 1,
          },
        ],
      },
      rows: 0,
      tabIndex: 0,
      isLoading: true,
      isBusy: false,
    };
  },
  validations: {
    form: {
      max_number_of_marketplace: { required, minValue: minValue(0) },
      max_number_of_automation: { required, minValue: minValue(0) },
      max_number_of_user: { required, minValue: minValue(0) },
      masterSettingSectionEntity_List: {
        required,
      },
    },
  },
  created() {
    this.getList();
  },

  methods: {
    async save() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      let payload = {
        ...this.form,
        settingSectionToggleRequest_list:
          this.form.masterSettingSectionEntity_List,
      };
      this.$bus.$emit("showLoading");

      const res = await this.axios.put(`setting/system_option/update`, payload);

      this.$bus.$emit("hideLoading");
      if (res.data.result == 1) {
        this.successAlert();
      } else this.errorAlert(res.data.message);
    },
    async getList() {
      this.isBusy = true;
      const response = await this.axios(`/setting/system_option`);
      this.form = response.data.detail;
      this.isBusy = false;
    },
  },
};
</script>
